import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoriesSection() {
  return (
    <section className="bg-background-100 py-8 md:py-10">
      <div className="container-page">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex items-center gap-3 bg-background-200/80 rounded-lg px-4 py-3.5 cursor-pointer group hover:bg-background-300/80 transition-all duration-300"
            >
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500/15 rounded-lg group-hover:bg-primary-500/25 transition-colors">
                <i className={`${cat.icon} text-primary-500 text-base`}></i>
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-foreground-800 text-sm font-medium whitespace-nowrap">{cat.name}</p>
                <p className="text-secondary-600 text-xs">{cat.count}条</p>
              </div>
              <i className="ri-arrow-right-s-line text-secondary-600 text-sm group-hover:text-foreground-800 transition-colors"></i>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}